export const actionType = {
    NEW: 2,
    RESET: 4,
    NEXT: 8,
    PREVIOUS: 16
}